import { Box } from '@mui/material'
import Preloader from 'ui/Preloader'

export const CowLoadSpinner = () => {
	// const rotateAnimation = keyframes`
	//   0% { transform: rotate(-10deg); }
	//   10% { transform: rotate(-10deg); }
	//   50% { transform: rotate(10deg); }
	//   60% { transform: rotate(10deg); }
	//   100% { transform: rotate(-10deg); }
	// `

	return (
		<Box
			sx={{
				display: 'flex',
				height: '72vh',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			<Box
				sx={{ justifySelf: 'center' }}
				// sx={{
				// 	animation: `${rotateAnimation} 1s infinite ease-in-out`,
				// }}
			>
				{/* <LoadPermissionsIcon stroke='#000' /> */}
				<Preloader />
			</Box>
		</Box>
	)
}
